// ErrorBoundary.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) return <Navigate to="/" replace />;
    return this.props.children;
  }
}

export default ErrorBoundary;